exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".page-parent--wrap[data-v-2be60429]{display:flex;flex-direction:column;height:100%}.page-parent[data-v-2be60429]{flex:0 0 auto}.page-son[data-v-2be60429]{flex:1}.page-action[data-v-2be60429]{margin-top:30px;width:100%;text-align:center}.page-action--item[data-v-2be60429]{display:inline-block;width:120px;height:30px;color:#fff;line-height:30px;background:#3f86ff;border:none;border-radius:5px;outline:none}", ""]);

// exports
